'use client'

import dynamic from 'next/dynamic'

import OrdersBidsDashboardSkeleton from './OrdersBidsDashboardSkeleton'

const OrdersBidsDashboardLoader = dynamic(
  () => import('./OrdersBidsDashboard'),
  {
    ssr: false,
    loading: () => <OrdersBidsDashboardSkeleton />,
  }
)

export default OrdersBidsDashboardLoader
